import { css } from '@emotion/react'
import { HTMLAttributes, memo } from 'react'
import ButtonX from '../Buttons/ButtonX'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import shape from '../styles/shape'
import { APP_FONT } from '../theme'

export const alertWrapperStyles = css({
    marginTop: 8,
    width: '100%',
    marginRight: 8,
    marginLeft: 8,
    fontFamily: APP_FONT,
})

const alertStyles = css({
    display: 'flex',
    fontSize: '0.875rem',
    borderRadius: shape.borderRadius,
    // width: '100%',
    padding: `${getThemeSpacing(0.75)} ${getThemeSpacing(2)}`,
    '& .alert-icon': {
        fontSize: 22,
        display: 'flex',
        opacity: 0.9,
        marginRight: 12,
        padding: '7px 0',
    },
    '& .alert-message': {
        width: '100%',
        // height: '100%',
        display: 'flex',
        padding: `${getThemeSpacing(1)} 0`,
    },
    '& svg': {
        fill: 'currentColor',
        display: 'inline-block',
        height: '1em',
        width: '1em',
        fontSize: 'inherit',
    },
    '& .alert-action': {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: `${getThemeSpacing(0.5)} 0 0 ${getThemeSpacing(2)}`,
        marginLeft: 'auto',
        marginRight: -8,
    },
})
const errorStyles = css({
    color: palette.mfcAlertError,
    background: palette.mfcAlertErrorBackground,
})
const warningStyles = css({
    color: palette.mfcAlertWarning,
    background: palette.mfcAlertWarningBackground,
})
const successStyles = css({
    color: palette.mfcAlertSuccess,
    background: palette.mfcAlertSuccessBackground,
})
const infoStyles = css({
    color: palette.mfcAlertInfo,
    background: palette.mfcAlertInfoBackground,
})

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
    severity: 'error' | 'success' | 'warning' | 'info'
    children: any
    icon?: boolean
    className?: string
    onClose?: any
}

const Alert = (props: AlertProps) => {
    const {
        children,
        severity = 'info',
        icon = true,
        className,
        onClose,
        ...rest
    } = props
    return (
        <div
            role="alert"
            className={className}
            css={[
                alertStyles,
                severity === 'error' && errorStyles,
                severity === 'success' && successStyles,
                severity === 'warning' && warningStyles,
                severity === 'info' && infoStyles,
            ]}
            {...rest}
        >
            {icon && (
                <div className="alert-icon">
                    <svg viewBox="0 0 24 24">
                        {severity === 'error' && (
                            <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                        )}
                        {severity === 'success' && (
                            <path d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
                        )}
                        {severity === 'warning' && (
                            <path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" />
                        )}
                        {severity === 'info' && (
                            <path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z" />
                        )}
                    </svg>
                </div>
            )}
            <div className="alert-message">{children}</div>
            {onClose && (
                <div className="alert-action">
                    <ButtonX onClick={onClose} />
                </div>
            )}
        </div>
    )
}

export default memo(Alert)
